import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const JournalClient = {
    /**
     *
     * Returns a calendar with a given id
     */
    GetJournal() {
        return clientFactory.get(API_URL + 'documents/journal');
    },
    CreateFolder(FolderName) {
        return clientFactory.post('documents/journal/folders', {
            name: FolderName
        })
    },
    AttachDocument(FolderId, DocumentId) {
        return clientFactory.post(API_URL + 'documents/journal/folders/' + FolderId + '/' + DocumentId)
    },
    UpdateFolder(FolderId, FolderName) {
        return clientFactory.put(API_URL + 'documents/journal/folders/' + FolderId, {
            name: FolderName
        })
    },
    DeleteFolder(FolderId) {
        return clientFactory.delete(API_URL + 'documents/journal/folders/' + FolderId)
    },
    MoveFolder(FolderId, parentFolderId) {
        return clientFactory.post(API_URL + 'documents/journal/folders/m/' + FolderId + '/' + parentFolderId)
    }

};